const _this = {

    $dom: {
		
    },

    vars: {
		
	},

    init : function() {
        this.accordion();
    },

    accordion: function() {
        $('.faq-question').first().addClass('active').next().slideDown();

        $('.faq-question').on('click', function() {
            $('.faq-question').not(this).removeClass('active').next().slideUp();
            $(this).toggleClass('active').next().slideToggle();
        });
	}
}

export default _this;